// @flow
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { EmphasizedSubText, Text } from 'trpc-react-native-ui';
import SubscriptionItem from '../../subscription/SubscriptionDetails/SubscriptionItem';
import { sortByDataVoiceSMSComparatorFactory } from '../../../lib/sort-options';
import FormatService from '../../../lib/format';
import { getTitle } from './lib/SubscriptionChangeDetailsService';

const blacklistedTitlesTypes = ['GOODWILL_CREDIT_OK'];

const SubscriptionChangeDetails = (props: Props) => {
  const price = props.amount ? FormatService.formatCentsToCurrency(props.amount, true) : null;
  const title = getTitle(props.type, props.credit, props.parameters);
  const filteredTypes = ['RLH', 'ROAMINGDATA', 'RAW'];

  return (
    <View>
      {!blacklistedTitlesTypes.includes(props.type) && (
        <View style={styles.header}>
          <EmphasizedSubText style={styles.title} emphStyle={styles.titleAddOn} text={title} />
          <Text style={styles.price}>{price}</Text>
        </View>
      )}
      {props.credit &&
        props.credit
          .filter(credit => !filteredTypes.some(type => credit.type.includes(type)))
          .sort(sortByDataVoiceSMSComparatorFactory(credit => credit.type))
          .map((credit, index) => <SubscriptionItem key={index} type={credit.type} value={credit.value} />)}
      {props.detail
        ? props.detail.map((detail, index) => <SubscriptionItem key={index} name={detail} type="DEFAULT" />)
        : null}
    </View>
  );
};

type Props = {
  credit?: Array<any>,
  detail?: Array<any>,
  amount?: string,
  type: string,
  parameters: Object,
};

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  title: {
    fontWeight: '600',
  },
  titleAddOn: {
    fontWeight: 'normal',
  },
  price: {
    fontSize: 16,
    color: 'grey',
    fontWeight: '600',
  },
});

export default SubscriptionChangeDetails;
